
import { css } from 'lit';
export default css`
pc-accordion{
  display:flex;
  flex-direction:column;
}

  pc-accordion pc-accordion-panel:last-child{
    border-bottom:2px solid var(--purple-medium-neutral);
  }

  @media print{

  pc-accordion pc-accordion-panel:last-child{
      border-bottom:none
  }
    }
`;